export enum UserType {
    NOT_MAPPED = "",
    CUSTOMER = "436a800e-6907-4f3e-9102-11eef63182da",
    TRUCKER = "f5d4a5a6-79eb-4cc8-a378-d937e26741c6",
}
